/**
 * 批量编辑创意
 */
import { Component, input, output } from '@angular/core';
import {
  BatchUploadConfig,
  BatchUploadModalComponent,
} from '@shared/components/batch-upload-modal/batch-upload-modal.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-batch-edit-creative',
  imports: [SharedModule, BatchUploadModalComponent],
  template: `
    <app-batch-upload-modal
      [isVisible]="isVisible()"
      [config]="uploadConfig"
      (isVisibleChange)="isVisibleChange.emit($event)"
      (nzOnOk)="nzOnOk()"
    ></app-batch-upload-modal>
  `,
})
export class BatchEditCreativeComponent {
  // 输入属性
  readonly isVisible = input<boolean>(false);

  // 输出事件
  readonly isVisibleChange = output<boolean>();

  // 上传配置
  uploadConfig: BatchUploadConfig = {
    title: '批量编辑创意',
    templateUrl:
      'https://static-cdn.linkworld.cn/xiaohong/红品智-推广-批量编辑创意模板_2026-01-22.xlsx',
    type: 9,
    description: '1、下载批量编辑创意模板，批量填写创意信息',
  };

  nzOnOk() {
    // 手动埋点 红品智-工具-批量编辑创意
    (window as any)?.lwTrackEvent?.add({
      event_id: 251,
      event_code: 'spotlight-tools-uploadUpdateCreativity',
      event_type: 'upload',
    });
  }
}
